import { createSlice } from '@reduxjs/toolkit';
import {
  addWheelStageOneData,
  fetchWheelStageOneList,
  deleteWheelStageOneData,
  fetchViewWheelStageOne,
  getWheelFlowHistory,
  // updateWheelFlowStatus,
  addWheelStageFourData,
  fetchWheelStageFourList,
  upadteStatusWheelStageFourData,
  addWheelStageTwoData,
  fetchWheelStageTwoList,
  addWheelStageThreeData,
  fetchWheelStageThreeList,
  fetchViewWheelStageThree,
  fetchWheelStageSixList,
  fetchViewWheelStageSix,
  viewWheelStageTwoData,
  addWheelStageTwoBrakeDiscData,
  fetchWheelStageTwoBrakeDiscList,
  viewWheelStageTwoBrakeDiscData,
  rejectWheelStageTwoBrakeDisc,
  storeWheelReportData,
  fetchWheelReportData,
} from './wheelThunk';

const initialState = {
  addUpdate: {
    loading: false,
    success: false,
    error: null,
  },
  addUpdateStageThree: {
    loading: false,
    success: false,
    error: null,
  },
  stageFourAddUpdate: {
    loading: false,
    success: false,
    error: null,
  },

  wheelStageOneList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },

  wheelStageThreeList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },

  wheelStageFourList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },
  wheelStageSixList: {
    loading: false,
    success: false,
    error: null,
    data: [],
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
    },
  },

  viewStageOne: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },

  flowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  delete: {
    loading: false,
    success: false,
    error: null,
  },
  updateStatusStageFourFive: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  wheelStageTwoList: {
    data: [],
    loading: false,
    pagination: {
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalPages: 0,
    },
  },
  viewStageSix: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  viewStageThree: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  viewStageTwo: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  wheelStageTwoBrakeDiscList: {
    data: [],
    loading: false,
    pagination: {
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalPages: 0,
    },
  },
  viewStageTwoBrakeDisc: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  brakeDiscAddUpdate: {
    loading: false,
    success: false,
    error: null,
  },

  storeWheelReport: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  wheelReportData: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
};

const wheelSlice = createSlice({
  name: 'wheel',
  initialState,

  reducers: {
    clearAddUpdateStatus: (state) => {
      state.addUpdate.success = false;
      state.addUpdate.error = null;
    },
    clearstageFourAddUpdateStatus: (state) => {
      state.stageFourAddUpdate.success = false;
      state.stageFourAddUpdate.error = null;
    },

    clearDeleteStatus: (state) => {
      state.delete.success = false;
      state.delete.error = null;
    },

    clearWheelData: (state) => {
      state.wheelStageOneList.data = [];
      state.viewStageOne.data = null;
      state.addUpdate.success = false;
      state.delete.success = false;
    },
    clearBrakeDiscAddUpdateStatus: (state) => {
      state.brakeDiscAddUpdate.success = false;
      state.brakeDiscAddUpdate.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // ==================== ADD / UPDATE ====================
      .addCase(addWheelStageOneData.pending, (state) => {
        state.addUpdate.loading = true;
        state.addUpdate.error = null;
      })
      .addCase(addWheelStageOneData.fulfilled, (state) => {
        state.addUpdate.loading = false;
        state.addUpdate.success = true;
      })
      .addCase(addWheelStageOneData.rejected, (state, action) => {
        state.addUpdate.loading = false;
        state.addUpdate.success = false;
        state.addUpdate.error = action.payload || 'Failed to save wheel stage one data';
      })
      // ==================== ADD / UPDATE ====================
      .addCase(addWheelStageFourData.pending, (state) => {
        state.stageFourAddUpdate.loading = true;
        state.stageFourAddUpdate.error = null;
      })
      .addCase(addWheelStageFourData.fulfilled, (state) => {
        state.stageFourAddUpdate.loading = false;
        state.stageFourAddUpdate.success = true;
      })
      .addCase(addWheelStageFourData.rejected, (state, action) => {
        state.stageFourAddUpdate.loading = false;
        state.stageFourAddUpdate.success = false;
        state.stageFourAddUpdate.error = action.payload || 'Failed to save wheel stage four data';
      })

      // ==================== FETCH LIST ====================
      .addCase(fetchWheelStageOneList.pending, (state) => {
        state.wheelStageOneList.loading = true;
        state.wheelStageOneList.error = null;
      })
      .addCase(fetchWheelStageOneList.fulfilled, (state, action) => {
        state.wheelStageOneList.loading = false;
        state.wheelStageOneList.success = true;
        state.wheelStageOneList.data = action.payload.data || [];
        state.wheelStageOneList.pagination = {
          currentPage: action.payload.current_page || 1,
          totalPages: action.payload.last_page || 1,
          totalItems: action.payload.total || 0,
          perPage: action.payload.per_page || 10,
        };
      })
      .addCase(fetchWheelStageOneList.rejected, (state, action) => {
        state.wheelStageOneList.loading = false;
        state.wheelStageOneList.success = false;
        state.wheelStageOneList.error = action.payload || 'Failed to fetch list';
      })

      // ==================== DELETE ====================
      .addCase(deleteWheelStageOneData.pending, (state) => {
        state.delete.loading = true;
        state.delete.error = null;
      })
      .addCase(deleteWheelStageOneData.fulfilled, (state) => {
        state.delete.loading = false;
        state.delete.success = true;
      })
      .addCase(deleteWheelStageOneData.rejected, (state, action) => {
        state.delete.loading = false;
        state.delete.success = false;
        state.delete.error = action.payload || 'Failed to delete';
      })

      // ==================== FLOW HISTORY ====================

      .addCase(getWheelFlowHistory.pending, (state) => {
        state.flowHistory.loading = true;
      })

      .addCase(getWheelFlowHistory.fulfilled, (state, action) => {
        state.flowHistory.loading = false;
        state.flowHistory.success = true;
        state.flowHistory.data = action.payload.data || [];
      })

      .addCase(getWheelFlowHistory.rejected, (state, action) => {
        state.flowHistory.loading = false;
        state.flowHistory.success = false;
        state.flowHistory.error = action.payload;
      })

      // ==================== VIEW ====================
      .addCase(fetchViewWheelStageOne.pending, (state) => {
        state.viewStageOne.loading = true;
        state.viewStageOne.error = null;
      })
      .addCase(fetchViewWheelStageOne.fulfilled, (state, action) => {
        state.viewStageOne.loading = false;
        state.viewStageOne.success = true;
        state.viewStageOne.data = action.payload.data || null;
      })
      .addCase(fetchViewWheelStageOne.rejected, (state, action) => {
        state.viewStageOne.loading = false;
        state.viewStageOne.success = false;
        state.viewStageOne.error = action.payload || 'Failed to fetch details';
      })
      // ==================== FETCH LIST ====================
      .addCase(fetchWheelStageFourList.pending, (state) => {
        state.wheelStageFourList.loading = true;
        state.wheelStageFourList.error = null;
      })
      // .addCase(fetchWheelStageFourList.fulfilled, (state, action) => {
      //   state.wheelStageFourList.loading = false;
      //   state.wheelStageFourList.success = true;
      //   state.wheelStageFourList.data = action.payload.data || [];
      //   state.wheelStageFourList.pagination = action.payload.pagination || {
      //     currentPage: 1,
      //     totalPages: 1,
      //     totalItems: 0,
      //     perPage: 10,
      //   };
      // })
      .addCase(fetchWheelStageFourList.fulfilled, (state, action) => {
        state.wheelStageFourList.loading = false;
        state.wheelStageFourList.success = true;
        state.wheelStageFourList.data = action.payload.data || [];

        state.wheelStageFourList.pagination = {
          currentPage: action.payload.current_page || 1,
          totalPages: action.payload.last_page || 1,
          totalItems: action.payload.total || 0,
          perPage: action.payload.per_page || 10,
        };
      })
      .addCase(fetchWheelStageFourList.rejected, (state, action) => {
        state.wheelStageFourList.loading = false;
        state.wheelStageFourList.success = false;
        state.wheelStageFourList.error = action.payload || 'Failed to fetch list';
      })

      .addCase(addWheelStageThreeData.pending, (state) => {
        state.addUpdateStageThree.loading = true;
        state.addUpdateStageThree.error = null;
      })
      .addCase(addWheelStageThreeData.fulfilled, (state) => {
        state.addUpdateStageThree.loading = false;
        state.addUpdateStageThree.success = true;
      })
      .addCase(addWheelStageThreeData.rejected, (state, action) => {
        state.addUpdateStageThree.loading = false;
        state.addUpdateStageThree.success = false;
        state.addUpdateStageThree.error = action.payload || 'Failed to save wheel stage six data';
      })

      .addCase(fetchWheelStageThreeList.pending, (state) => {
        state.wheelStageThreeList.loading = true;
        state.wheelStageThreeList.error = null;
      })
      .addCase(fetchWheelStageThreeList.fulfilled, (state, action) => {
        state.wheelStageThreeList.loading = false;
        state.wheelStageThreeList.success = true;
        state.wheelStageThreeList.data = action.payload.data || [];

        state.wheelStageThreeList.pagination = {
          currentPage: action.payload.current_page || 1,
          totalPages: action.payload.last_page || 1,
          totalItems: action.payload.total || 0,
          perPage: action.payload.per_page || 10,
        };
      })
      .addCase(fetchWheelStageThreeList.rejected, (state, action) => {
        state.wheelStageThreeList.loading = false;
        state.wheelStageThreeList.success = false;
        state.wheelStageThreeList.error = action.payload || 'Failed to fetch list';
      })

      .addCase(fetchViewWheelStageThree.pending, (state) => {
        state.viewStageThree.loading = true;
        state.viewStageThree.error = null;
      })
      .addCase(fetchViewWheelStageThree.fulfilled, (state, action) => {
        state.viewStageThree.loading = false;
        state.viewStageThree.success = true;
        state.viewStageThree.data = action.payload.data || null;
      })
      .addCase(fetchViewWheelStageThree.rejected, (state, action) => {
        state.viewStageThree.loading = false;
        state.viewStageThree.success = false;
        state.viewStageThree.error = action.payload || 'Failed to fetch details';
      })

      .addCase(fetchWheelStageSixList.pending, (state) => {
        state.wheelStageSixList.loading = true;
        state.wheelStageSixList.error = null;
      })
      .addCase(fetchWheelStageSixList.fulfilled, (state, action) => {
        state.wheelStageSixList.loading = false;
        state.wheelStageSixList.success = true;
        state.wheelStageSixList.data = action.payload.data || [];

        state.wheelStageSixList.pagination = {
          currentPage: action.payload.current_page || 1,
          totalPages: action.payload.last_page || 1,
          totalItems: action.payload.total || 0,
          perPage: action.payload.per_page || 10,
        };
      })
      .addCase(fetchWheelStageSixList.rejected, (state, action) => {
        state.wheelStageSixList.loading = false;
        state.wheelStageSixList.success = false;
        state.wheelStageSixList.error = action.payload || 'Failed to fetch list';
      })

      .addCase(fetchViewWheelStageSix.pending, (state) => {
        state.viewStageSix.loading = true;
        state.viewStageSix.error = null;
      })
      .addCase(fetchViewWheelStageSix.fulfilled, (state, action) => {
        state.viewStageSix.loading = false;
        state.viewStageSix.success = true;
        state.viewStageSix.data = action.payload.data || null;
      })
      .addCase(fetchViewWheelStageSix.rejected, (state, action) => {
        state.viewStageSix.loading = false;
        state.viewStageSix.success = false;
        state.viewStageSix.error = action.payload || 'Failed to fetch details';
      })

      .addCase(upadteStatusWheelStageFourData.pending, (state) => {
        state.updateStatusStageFourFive.loading = true;
        state.updateStatusStageFourFive.error = null;
      })
      .addCase(upadteStatusWheelStageFourData.fulfilled, (state) => {
        state.updateStatusStageFourFive.loading = false;
        state.updateStatusStageFourFive.success = true;
      })
      .addCase(upadteStatusWheelStageFourData.rejected, (state, action) => {
        state.updateStatusStageFourFive.loading = false;
        state.updateStatusStageFourFive.success = false;
        state.updateStatusStageFourFive.error =
          action.payload || 'Failed to save wheel stage four data';
      })

      //stage two
      .addCase(addWheelStageTwoData.pending, (state) => {
        state.addUpdate.loading = true;
        state.addUpdate.error = null;
      })
      .addCase(addWheelStageTwoData.fulfilled, (state) => {
        state.addUpdate.loading = false;
        state.addUpdate.success = true;
      })
      .addCase(addWheelStageTwoData.rejected, (state, action) => {
        state.addUpdate.loading = false;
        state.addUpdate.success = false;
        state.addUpdate.error = action.payload || 'Failed to save wheel stage two data';
      })
      .addCase(fetchWheelStageTwoList.pending, (state) => {
        state.wheelStageTwoList.loading = true;
      })
      .addCase(fetchWheelStageTwoList.fulfilled, (state, action) => {
        state.wheelStageTwoList.loading = false;
        state.wheelStageTwoList.data = action.payload.data;
        state.wheelStageTwoList.pagination = {
          currentPage: action.payload.current_page,
          perPage: action.payload.per_page,
          totalItems: action.payload.total,
          totalPages: action.payload.last_page,
        };
      })
      .addCase(fetchWheelStageTwoList.rejected, (state) => {
        state.wheelStageTwoList.loading = false;
        state.wheelStageTwoList.data = [];
      })
      .addCase(viewWheelStageTwoData.pending, (state) => {
        state.viewStageTwo.loading = true;
        state.viewStageTwo.error = null;
      })
      .addCase(viewWheelStageTwoData.fulfilled, (state, action) => {
        state.viewStageTwo.loading = false;
        state.viewStageTwo.success = true;
        state.viewStageTwo.data = action.payload.data || null;
      })
      .addCase(viewWheelStageTwoData.rejected, (state, action) => {
        state.viewStageTwo.loading = false;
        state.viewStageTwo.success = false;
        state.viewStageTwo.error = action.payload || 'Failed to fetch stage two details';
      })
      .addCase(addWheelStageTwoBrakeDiscData.pending, (state) => {
        state.brakeDiscAddUpdate.loading = true;
        state.brakeDiscAddUpdate.error = null;
      })
      .addCase(addWheelStageTwoBrakeDiscData.fulfilled, (state) => {
        state.brakeDiscAddUpdate.loading = false;
        state.brakeDiscAddUpdate.success = true;
      })
      .addCase(addWheelStageTwoBrakeDiscData.rejected, (state, action) => {
        state.brakeDiscAddUpdate.loading = false;
        state.brakeDiscAddUpdate.success = false;
        state.brakeDiscAddUpdate.error =
          action.payload || 'Failed to save brake disc stage two data';
      })

      .addCase(fetchWheelStageTwoBrakeDiscList.pending, (state) => {
        state.wheelStageTwoBrakeDiscList.loading = true;
      })
      .addCase(fetchWheelStageTwoBrakeDiscList.fulfilled, (state, action) => {
        state.wheelStageTwoBrakeDiscList.loading = false;
        state.wheelStageTwoBrakeDiscList.data = action.payload.data;
        state.wheelStageTwoBrakeDiscList.pagination = {
          currentPage: action.payload.current_page,
          perPage: action.payload.per_page,
          totalItems: action.payload.total,
          totalPages: action.payload.last_page,
        };
      })
      .addCase(fetchWheelStageTwoBrakeDiscList.rejected, (state) => {
        state.wheelStageTwoBrakeDiscList.loading = false;
        state.wheelStageTwoBrakeDiscList.data = [];
      })

      .addCase(viewWheelStageTwoBrakeDiscData.pending, (state) => {
        state.viewStageTwoBrakeDisc.loading = true;
        state.viewStageTwoBrakeDisc.error = null;
      })
      .addCase(viewWheelStageTwoBrakeDiscData.fulfilled, (state, action) => {
        state.viewStageTwoBrakeDisc.loading = false;
        state.viewStageTwoBrakeDisc.success = true;
        state.viewStageTwoBrakeDisc.data = action.payload.data || null;
      })
      .addCase(viewWheelStageTwoBrakeDiscData.rejected, (state, action) => {
        state.viewStageTwoBrakeDisc.loading = false;
        state.viewStageTwoBrakeDisc.success = false;
        state.viewStageTwoBrakeDisc.error =
          action.payload || 'Failed to fetch brake disc stage two details';
      })

      .addCase(storeWheelReportData.pending, (state) => {
        state.storeWheelReport.loading = true;
        state.storeWheelReport.error = null;
      })
      .addCase(storeWheelReportData.fulfilled, (state) => {
        state.storeWheelReport.loading = false;
        state.storeWheelReport.success = true;
      })
      .addCase(storeWheelReportData.rejected, (state, action) => {
        state.storeWheelReport.loading = false;
        state.storeWheelReport.success = false;
        state.storeWheelReport.error = action.payload || 'Failed to update wheel report data';
      })

      .addCase(rejectWheelStageTwoBrakeDisc.pending, (state) => {
        state.brakeDiscAddUpdate.loading = true;
        state.brakeDiscAddUpdate.error = null;
      })
      .addCase(rejectWheelStageTwoBrakeDisc.fulfilled, (state) => {
        state.brakeDiscAddUpdate.loading = false;
        state.brakeDiscAddUpdate.success = true;
      })
      .addCase(rejectWheelStageTwoBrakeDisc.rejected, (state, action) => {
        state.brakeDiscAddUpdate.loading = false;
        state.brakeDiscAddUpdate.success = false;
        state.brakeDiscAddUpdate.error = action.payload || 'Failed to reject brake disc';
      })
      .addCase(fetchWheelReportData.pending, (state) => {
        state.wheelReportData.loading = true;
        state.wheelReportData.error = null;
      })
      .addCase(fetchWheelReportData.fulfilled, (state, action) => {
        state.wheelReportData.loading = false;
        state.wheelReportData.success = true;
        state.wheelReportData.data = action.payload.data || null;
      })
      .addCase(fetchWheelReportData.rejected, (state, action) => {
        state.wheelReportData.loading = false;
        state.wheelReportData.success = false;
        state.wheelReportData.error =
          action.payload || 'Failed to fetch  details';
      })
      ;
  },
});

export const {
  clearAddUpdateStatus,
  clearDeleteStatus,
  clearWheelData,
  clearstageFourAddUpdateStatus,
  clearBrakeDiscAddUpdateStatus,
} = wheelSlice.actions;

export default wheelSlice.reducer;
